export default __webpack_public_path__ + "static/media/NPRLogo.aa0aa676.png";